module.exports = __webpack_public_path__ + "static/media/ensuite.d6ff3c66.jpg";